export const LINK_FS_EN =
  'https://docs.fiingate.vn/manual/user-manual/manage-report/order-and-generate-report/dynamic-reports#note-how-to-set-up-fs'
export const LINK_FS_VI =
  'https://docs.fiingate.vn/manual/v/2/user-manual/manage-report/order-and-generate-report/dynamic-reports'
